<template>
	<div class="zoom">
  		<div class="photo1" ref="photo" v-parallax-fit="photo1"></div>
  	</div>
</template>

<script>
export default {
  name: 'slide31',
  data() {
    return {
      photo1: [
      {
          start: 40400,
          end: 40750,
          fromStyle: { transform: 'translateY(-1200px)' },
          toStyle: { transform: 'translateY(0px)' }
        },
        {
          start: 40800,
          end: 41000,
          fromStyle: { transform: 'translateY(0px)' },
          toStyle: { transform: 'translateY(260px)' }
        },
        {
          start: 42000,
          end: 42700,
          fromStyle: { transform: 'translateY(260px)' },
          toStyle: { transform: 'translateY(1800px)' }
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.photo1 {
    position: fixed;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/31_FinalPhoto.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 530px;
    height: 630px;
    transition: 0.3s;
    transform-origin: center;
    z-index: 5;
    left: calc(50% - 266px);
    top: 10vh;
    @media(min-width: 600px) and (max-width: 1280px) {
      top: 0;
      zoom: 0.65;
    }
    @media(max-width: 600px) {
      left: calc(50% - 106px);
      width: 220px;
      height: 450px;
    }
    @media(max-width: 400px) {
      	left: calc(50% - 106px);
		width: 200px;
		height: 250px;
		top: 35%;
	}
}
</style>
